import { Component, OnInit, ViewChildren, QueryList } from '@angular/core';
import { Observable } from 'rxjs';
import { AircraftEventFacade } from '../+state/aircraft-event/aircraft-event.facade';
import {
  AircraftEventSkeleton,
  AircraftEventAudit,
  AircraftEventBusinessPersonAudit,
  ScheduledEventAudit
} from '../+models/aircraft-event-audit.model';
import { AircraftEventAuditListComponent } from './aircraft-event-audit-list/aircraft-event-audit-list.component';
import { RefTypeItem } from '@sd-portal/shared/ref-type-item';

@Component({
  selector: 'sd-portal-aircraft-event-audit',
  templateUrl: './aircraft-event.component.html',
  styleUrls: ['./aircraft-event.component.scss']
})
export class AircraftEventComponent implements OnInit {
  aircraftEventSkeletonsLoaded$: Observable<boolean>;
  aircraftEventSkeletonsLoading$: Observable<boolean>;
  aircraftEventSkeletons$: Observable<AircraftEventSkeleton[]>;

  aircraftEventAuditsLoaded$: Observable<boolean>;
  aircraftEventAuditsLoading$: Observable<boolean>;
  aircraftEventAudits$: Observable<AircraftEventAudit[]>;

  aircraftEventBusinessPersonAuditLoaded$: Observable<boolean>;
  aircraftEventBusinessPersonAuditsLoading$: Observable<boolean>;
  aircraftEventBusinessPersonAudits$: Observable<AircraftEventBusinessPersonAudit[]>;

  scheduledEventAuditsLoaded$: Observable<boolean>;
  scheduledEventAuditsLoading$: Observable<boolean>;
  scheduledEventAudits$: Observable<ScheduledEventAudit[]>;

  aircraftEventTypesLoaded$: Observable<boolean>;
  aircraftEventTypesLoading$: Observable<boolean>;
  aircraftEventTypes$: Observable<RefTypeItem[]>;

  flightBusinessPersonTypesLoaded$: Observable<boolean>;
  flightBusinessPersonTypesLoading$: Observable<boolean>;
  flightBusinessPersonTypes$: Observable<RefTypeItem[]>;

  @ViewChildren(AircraftEventAuditListComponent)
  aircraftEventAuditLists: QueryList<AircraftEventAuditListComponent>;

  constructor(private readonly aircraftEventFacade: AircraftEventFacade) {}

  ngOnInit() {
    this.aircraftEventSkeletonsLoaded$ = this.aircraftEventFacade.aircraftEventSkeletonsLoaded$;
    this.aircraftEventSkeletonsLoading$ = this.aircraftEventFacade.aircraftEventSkeletonsLoading$;
    this.aircraftEventSkeletons$ = this.aircraftEventFacade.aircraftEventSkeletons$;

    this.aircraftEventAuditsLoaded$ = this.aircraftEventFacade.aircraftEventAuditLoaded$;
    this.aircraftEventAuditsLoading$ = this.aircraftEventFacade.aircraftEventAuditLoading$;
    this.aircraftEventAudits$ = this.aircraftEventFacade.aircraftEventAudits$;

    this.aircraftEventBusinessPersonAuditLoaded$ =
      this.aircraftEventFacade.aircraftEventBusinessPersonAuditLoaded$;
    this.aircraftEventBusinessPersonAuditsLoading$ =
      this.aircraftEventFacade.aircraftEventBusinessPersonAuditLoading$;
    this.aircraftEventBusinessPersonAudits$ =
      this.aircraftEventFacade.aircraftEventBusinessPersonAudits$;

    this.scheduledEventAuditsLoaded$ = this.aircraftEventFacade.scheduledEventAuditLoaded$;
    this.scheduledEventAuditsLoading$ = this.aircraftEventFacade.scheduledEventAuditLoading$;
    this.scheduledEventAudits$ = this.aircraftEventFacade.scheduledEventAudits$;

    this.aircraftEventTypesLoaded$ = this.aircraftEventFacade.aircraftEventTypesLoaded$;
    this.aircraftEventTypesLoading$ = this.aircraftEventFacade.aircraftEventTypesLoading$;
    this.aircraftEventTypes$ = this.aircraftEventFacade.aircraftEventTypes$;

    this.flightBusinessPersonTypesLoaded$ =
      this.aircraftEventFacade.flightBusinessPersonTypesLoaded$;
    this.flightBusinessPersonTypesLoading$ =
      this.aircraftEventFacade.flightBusinessPersonTypesLoading$;
    this.flightBusinessPersonTypes$ = this.aircraftEventFacade.flightBusinessPersonTypes$;

    this.aircraftEventFacade.loadAircraftEvents();
  }

  loadAircraftEventAudits(aircraftEventId: number) {
    this.aircraftEventFacade.loadAircraftEventAudits(aircraftEventId);
  }

  nextAircraftEventAuditPage(aircraftEventId: number) {
    this.aircraftEventFacade.nextPageAircraftEventAudits(aircraftEventId);
  }

  loadAircraftEventBusinessPersonAudits(aircraftEventBusinessPersonId: number) {
    this.aircraftEventFacade.loadAircraftEventBusinessPersonAudits(aircraftEventBusinessPersonId);
  }

  nextAircraftEventBusinessPersonAuditPage(aircraftEventBusinessPersonId: number) {
    this.aircraftEventFacade.nextPageAircraftEventBusinessPersonAudits(
      aircraftEventBusinessPersonId
    );
  }

  loadScheduledEventAudits(scheduledEventId: number) {
    this.aircraftEventFacade.loadScheduledEventAudits(scheduledEventId);
  }

  nextScheduledEventAuditPage(scheduledEventId: number) {
    this.aircraftEventFacade.nextPageScheduledEventAudits(scheduledEventId);
  }

  aircraftEventOpened(aircraftEvent: AircraftEventSkeleton) {
    setTimeout(() => {
      const match = this.aircraftEventAuditLists.find(
        c => c.aircraftEvent.aircraftEventId === aircraftEvent.aircraftEventId
      );
      if (!match) {
        return;
      }
      match.loadData();
    });
  }

  getAircraftEventTypeName(aircraftEventTypes: RefTypeItem[], aircraftEventTypeId: number) {
    const aircraftEventType = aircraftEventTypes.find(a => a.id === aircraftEventTypeId);
    if (!aircraftEventType) {
      return 'N/A';
    }
    return aircraftEventType.name;
  }
}
